var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chart',{ref:"chart",staticStyle:{"width":"100%%"},attrs:{"auto-resize":true}})}
var staticRenderFns = []

export { render, staticRenderFns }